import Box from '@mui/material/Box';

import Main from './Main';
import Header from './Header';
import MiniSideNav from './MiniSideNav';

function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <Box id="root__layout">
      <Header />
      <MiniSideNav />
      <Main>{children}</Main>
    </Box>
  );
}

export default AppLayout;
